import { TemplateEditViews } from 'modules/templateEditor/common';
import { useTemplateTakeover } from 'modules/templateEditor/integrations/InStudioTemplateEditing/context';
import { PrimaryButton, SecondaryButton } from 'ui/button';
import { TemplatesEmptyState } from 'ui/illustrations';
import {
  CampaignTemplateContainer,
  TemplateContentContainer,
  TemplateContentTitle,
  TemplateContentBody,
  Buttons,
} from './TemplateContent.styles';
import { useTemplateContext } from '../../context';

export const NoTemplateContent = () => {
  const { refetch, isLoading } = useTemplateContext();
  const takeover = useTemplateTakeover();
  return (
    <CampaignTemplateContainer>
      <TemplatesEmptyState />
      <TemplateContentContainer>
        <TemplateContentTitle>Missing campaign content</TemplateContentTitle>
        <TemplateContentBody>
          We can&apos;t seem to find this template. Try refreshing or browse to select a new
          template.
        </TemplateContentBody>
      </TemplateContentContainer>
      <Buttons id="not-template-selection-buttons">
        <SecondaryButton onClick={() => takeover.open(TemplateEditViews.select)}>
          Browse templates
        </SecondaryButton>
        <PrimaryButton isLoading={isLoading} onClick={refetch}>
          Refresh template
        </PrimaryButton>
      </Buttons>
    </CampaignTemplateContainer>
  );
};
